













import {Component, Emit, Prop, Vue} from 'vue-property-decorator';
import {RateRuleSelectListItem, StSelectListItem} from '@/services/api/nswag/stapiclient_generated';

@Component({
    components: {
    },
})
export default class RateRuleSelect extends Vue {
    @Prop()items!: RateRuleSelectListItem[];
    @Prop()value!: Array<number>;

    selected(item: RateRuleSelectListItem){
        return this.value.some(x=>x == item.id)
    }

    @Emit('input')
    input(item: RateRuleSelectListItem){
        const selected = !this.selected(item);

        let result = JSON.parse(JSON.stringify(this.value));

        if(selected){
            result.push(item.id!);
        }else{
            result.splice(result.findIndex((x: number)=>x == item.id!),1);
        }

        return result;
    }
}
